import React from 'react';

import {Skeleton, Stack, Button} from 'views/components';
import {EditCalendar as EditCalendarIcon, Cancel as CancelIcon, ArrowBack as ArrowBackIcon} from 'views/icons';
import {Translate, useNavigate} from 'views/module';

const EventHeaderSkeleton = () => {
  const navigate = useNavigate();

  return (
    <Stack
      direction={{xs: 'column', sm: 'row'}}
      alignItems={{xs: 'flex-start', sm: 'center'}}
      justifyContent="space-between"
      mb={2}
      spacing={1}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{flexWrap: 'wrap', minWidth: 0}}
      >
        <ArrowBackIcon
          sx={{color: 'black', cursor: 'pointer', mr: 1}}
          onClick={() => {
            if (window.history.length > 1) {
              navigate(-1);
            } else {
              navigate('/schedule/client');
            }
          }}
        />
        <Skeleton variant="rectangular" width={80} height={28} sx={{borderRadius: 2, mr: 1, mb: {xs: 0.5, sm: 0}}} />
        <Skeleton variant="text" width={100} height={28} sx={{maxWidth: {xs: '180px', sm: 'none'}, flexShrink: 1}} />
      </Stack>
      <Stack
        direction={{xs: 'column', sm: 'row'}}
        spacing={1}
        sx={{width: {xs: '100%', sm: 'auto'}, mt: {xs: 1, sm: 0}}}
      >
        <Button
          variant="outlined"
          color="black"
          startIcon={<EditCalendarIcon />}
          sx={{width: {xs: '100%', sm: 'auto'}}}
          disabled
        >
          <Translate expression='schedule.eventDetail.Header.RescheduleButton'/>
        </Button>
        <Button
          variant="outlined"
          color="error"
          startIcon={<CancelIcon />}
          sx={{width: {xs: '100%', sm: 'auto'}}}
          disabled
        >
          <Translate expression='schedule.eventDetail.Header.CancelButton'/>
        </Button>
      </Stack>
    </Stack>
  );
};

export default EventHeaderSkeleton;
